"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class CardIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(0.000000, 4.000000)" },
                        React.createElement("path", { d: "M21.5,0 L2.5,0 C1.121,0 0,1.122 0,2.5 L0,4 L24,4 L24,2.5 C24,1.122 22.878,0 21.5,0" }),
                        React.createElement("path", { d: "M3.5,9.0005 L6.5,9.0005 C6.775,9.0005 7,9.2245 7,9.5005 C7,9.7765 6.775,10.0005 6.5,10.0005 L3.5,10.0005 C3.224,10.0005 3,9.7765 3,9.5005 C3,9.2245 3.224,9.0005 3.5,9.0005 L3.5,9.0005 Z M3.5,7.0005 L11.5,7.0005 C11.775,7.0005 12,7.2245 12,7.5005 C12,7.7765 11.775,8.0005 11.5,8.0005 L3.5,8.0005 C3.224,8.0005 3,7.7765 3,7.5005 C3,7.2245 3.224,7.0005 3.5,7.0005 L3.5,7.0005 Z M17.5,7.0005 L20.5,7.0005 C20.775,7.0005 21,7.2245 21,7.5005 C21,7.7765 20.775,8.0005 20.5,8.0005 L17.5,8.0005 C17.224,8.0005 17,7.7765 17,7.5005 C17,7.2245 17.224,7.0005 17.5,7.0005 L17.5,7.0005 Z M0,12.5005 C0,13.8785 1.121,15.0005 2.5,15.0005 L21.5,15.0005 C22.878,15.0005 24,13.8785 24,12.5005 L24,5.0005 L0,5.0005 L0,12.5005 Z" }))))));
    }
}
exports.CardIcon = CardIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/card.tsx
// module id = 2130
// module chunks = 0 1 2